<template>
  <transition name="ag-modal">
    <div
      :id="id"
      class="ag-modal__overlay fixed inset-0 flex items-center justify-center"
      :aria-hidden="false"
      @click.self="shortcutClose"
    >
      <div class="ag-modal__container rounded shadow-lg">
        <header class="px-10 py-5 bg-blue-600 rounded-t flex justify-between">
          <h3 class="text-lg text-white flex-1" :id="`${id}-title`">
            <slot name="title" />
          </h3>
          <button
            type="button"
            class="focus:outline-none"
            aria-label="Close modal"
            :aria-controls="id"
            @click="close"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 10.5867L16.95 5.63672L18.364 7.05072L13.414 12.0007L18.364 16.9507L16.95 18.3647L12 13.4147L7.04999 18.3647L5.63599 16.9507L10.586 12.0007L5.63599 7.05072L7.04999 5.63672L12 10.5867Z"
                fill="#BEE3F8"
              />
            </svg>
          </button>
        </header>
        <main :id="`${id}-content`" class="py-4 pb-5 px-4 md:px-10 bg-gray-100">
          <slot name="content" />
        </main>
      </div>
    </div>
  </transition>
</template>
<script>
import { removeScroll } from '../utils';
export default {
  name: 'ag-modal',
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  created() {
    removeScroll(true);
  },
  beforeDestroy() {
    removeScroll();
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.ag-modal__overlay {
  background: rgba(0, 0, 0, 0.6);
  z-index: 1050;
}
.ag-modal__container {
  width: 655px;
}
</style>
